import type { Resource } from "i18next";

import bgNavigation from "@/locales/bg/navigation";
import bgFooter from "@/locales/bg/footer";
import bgHome from "@/locales/bg/home";
import bgImplantology from "@/locales/bg/implantology";
import bgEndodontics from "@/locales/bg/endodontics";
import bgOralSurgery from "@/locales/bg/oral-surgery";
import bgPeriodontology from "@/locales/bg/periodontology";
import bgOrthodontics from "@/locales/bg/orthodontics";
import bgBonding from "@/locales/bg/bonding";
import bgProsthetics from "@/locales/bg/prosthetics";
import bgLipFiller from "@/locales/bg/lip-filler";
import bgCariesology from "@/locales/bg/cariesology";
import bgTeethWhitening from "@/locales/bg/teeth-whitening";
import bgDentalTourism from "@/locales/bg/dental-tourism";
import bgPrices from "@/locales/bg/prices";
import bgRequestQuote from "@/locales/bg/request-quote";
import bgPrivacyPolicy from "@/locales/bg/privacy-policy";
import bgTermsOfService from "@/locales/bg/terms-of-service";
import bgNotFound from "@/locales/bg/not-found";
import bgSeo from "@/locales/bg/seo";

import enNavigation from "@/locales/en/navigation";
import enFooter from "@/locales/en/footer";
import enHome from "@/locales/en/home";
import enImplantology from "@/locales/en/implantology";
import enEndodontics from "@/locales/en/endodontics";
import enOralSurgery from "@/locales/en/oral-surgery";
import enPeriodontology from "@/locales/en/periodontology";
import enOrthodontics from "@/locales/en/orthodontics";
import enBonding from "@/locales/en/bonding";
import enProsthetics from "@/locales/en/prosthetics";
import enLipFiller from "@/locales/en/lip-filler";
import enCariesology from "@/locales/en/cariesology";
import enTeethWhitening from "@/locales/en/teeth-whitening";
import enDentalTourism from "@/locales/en/dental-tourism";
import enPrices from "@/locales/en/prices";
import enRequestQuote from "@/locales/en/request-quote";
import enPrivacyPolicy from "@/locales/en/privacy-policy";
import enTermsOfService from "@/locales/en/terms-of-service";
import enNotFound from "@/locales/en/not-found";
import enSeo from "@/locales/en/seo";

import deNavigation from "@/locales/de/navigation";
import deFooter from "@/locales/de/footer";
import deHome from "@/locales/de/home";
import deImplantology from "@/locales/de/implantology";
import deEndodontics from "@/locales/de/endodontics";
import deOralSurgery from "@/locales/de/oral-surgery";
import dePeriodontology from "@/locales/de/periodontology";
import deOrthodontics from "@/locales/de/orthodontics";
import deBonding from "@/locales/de/bonding";
import deProsthetics from "@/locales/de/prosthetics";
import deLipFiller from "@/locales/de/lip-filler";
import deCariesology from "@/locales/de/cariesology";
import deTeethWhitening from "@/locales/de/teeth-whitening";
import deDentalTourism from "@/locales/de/dental-tourism";
import dePrices from "@/locales/de/prices";
import deRequestQuote from "@/locales/de/request-quote";
import dePrivacyPolicy from "@/locales/de/privacy-policy";
import deTermsOfService from "@/locales/de/terms-of-service";
import deNotFound from "@/locales/de/not-found";
import deSeo from "@/locales/de/seo";

import grNavigation from "@/locales/gr/navigation";
import grFooter from "@/locales/gr/footer";
import grHome from "@/locales/gr/home";
import grImplantology from "@/locales/gr/implantology";
import grEndodontics from "@/locales/gr/endodontics";
import grOralSurgery from "@/locales/gr/oral-surgery";
import grPeriodontology from "@/locales/gr/periodontology";
import grOrthodontics from "@/locales/gr/orthodontics";
import grBonding from "@/locales/gr/bonding";
import grProsthetics from "@/locales/gr/prosthetics";
import grLipFiller from "@/locales/gr/lip-filler";
import grCariesology from "@/locales/gr/cariesology";
import grTeethWhitening from "@/locales/gr/teeth-whitening";
import grDentalTourism from "@/locales/gr/dental-tourism";
import grPrices from "@/locales/gr/prices";
import grRequestQuote from "@/locales/gr/request-quote";
import grPrivacyPolicy from "@/locales/gr/privacy-policy";
import grTermsOfService from "@/locales/gr/terms-of-service";
import grNotFound from "@/locales/gr/not-found";
import grSeo from "@/locales/gr/seo";

export const resources: Resource = {
  bg: {
    navigation: bgNavigation,
    footer: bgFooter,
    home: bgHome,
    implantology: bgImplantology,
    endodontics: bgEndodontics,
    "oral-surgery": bgOralSurgery,
    periodontology: bgPeriodontology,
    orthodontics: bgOrthodontics,
    bonding: bgBonding,
    prosthetics: bgProsthetics,
    "lip-filler": bgLipFiller,
    cariesology: bgCariesology,
    "teeth-whitening": bgTeethWhitening,
    "dental-tourism": bgDentalTourism,
    prices: bgPrices,
    "request-quote": bgRequestQuote,
    "privacy-policy": bgPrivacyPolicy,
    "terms-of-service": bgTermsOfService,
    "not-found": bgNotFound,
    seo: bgSeo,
  },
  en: {
    navigation: enNavigation,
    footer: enFooter,
    home: enHome,
    implantology: enImplantology,
    endodontics: enEndodontics,
    "oral-surgery": enOralSurgery,
    periodontology: enPeriodontology,
    orthodontics: enOrthodontics,
    bonding: enBonding,
    prosthetics: enProsthetics,
    "lip-filler": enLipFiller,
    cariesology: enCariesology,
    "teeth-whitening": enTeethWhitening,
    "dental-tourism": enDentalTourism,
    prices: enPrices,
    "request-quote": enRequestQuote,
    "privacy-policy": enPrivacyPolicy,
    "terms-of-service": enTermsOfService,
    "not-found": enNotFound,
    seo: enSeo,
  },
  de: {
    navigation: deNavigation,
    footer: deFooter,
    home: deHome,
    implantology: deImplantology,
    endodontics: deEndodontics,
    "oral-surgery": deOralSurgery,
    periodontology: dePeriodontology,
    orthodontics: deOrthodontics,
    bonding: deBonding,
    prosthetics: deProsthetics,
    "lip-filler": deLipFiller,
    cariesology: deCariesology,
    "teeth-whitening": deTeethWhitening,
    "dental-tourism": deDentalTourism,
    prices: dePrices,
    "request-quote": deRequestQuote,
    "privacy-policy": dePrivacyPolicy,
    "terms-of-service": deTermsOfService,
    "not-found": deNotFound,
    seo: deSeo,
  },
  gr: {
    navigation: grNavigation,
    footer: grFooter,
    home: grHome,
    implantology: grImplantology,
    endodontics: grEndodontics,
    "oral-surgery": grOralSurgery,
    periodontology: grPeriodontology,
    orthodontics: grOrthodontics,
    bonding: grBonding,
    prosthetics: grProsthetics,
    "lip-filler": grLipFiller,
    cariesology: grCariesology,
    "teeth-whitening": grTeethWhitening,
    "dental-tourism": grDentalTourism,
    prices: grPrices,
    "request-quote": grRequestQuote,
    "privacy-policy": grPrivacyPolicy,
    "terms-of-service": grTermsOfService,
    "not-found": grNotFound,
    seo: grSeo,
  },
};
